import type { AppContext } from 'types/common'
import component from './Report.svelte'
import { checkSessionPermission } from 'utility/permission'
import showErrorAndRedirect from 'utility/show-error-and-redirect'

export default ({ mediator, stateRouter }: AppContext) => {
	stateRouter.addState({
		name: 'app.configuration.dashboard.report',
		route: 'report',
		querystringParameters: ['lastSaveTime'],
		defaultParameters: {
			dashboardReportId: null,
		},
		template: {
			svelte: true,
			component,
		},
		resolve(_data, parameters) {
			if (
				!checkSessionPermission('DASHBOARD_REPORT_EDIT_OWN') &&
				!checkSessionPermission('DASHBOARD_REPORT_EDIT_ALL')
			) {
				throw showErrorAndRedirect(
					mediator,
					'Permission Denied',
					'You do not have permission to edit dashboard reports.',
					{
						name: 'app.configuration',
					},
				)
			}

			return Promise.resolve({
				dashboardReportId: parameters.dashboardReportId ? parseInt(parameters.dashboardReportId, 10) : null,
			})
		},
	})
}
